export const FilterTypes = {
  ALL: undefined,
  ARCHIVED: 'archived',
  CANVASSED: 'canvassed',
  FRIENDS: 'friends',
  NEEDS_ATTENTION: 'needs_attention',
  TEAM: 'team',
  UNREAD: 'unread',
};
